import api from '../../domain/api';
import {
  GET_ACTIVITYCYCLES_STATED,
  GET_ACTIVITYCYCLES,
  GET_ACTIVITYCYCLES_ENDED,
  ADD_ACTIVITYCYCLE_STATED,
  ADD_ACTIVITYCYCLE,
  ADD_ACTIVITYCYCLE_ENDED,
  EDIT_ACTIVITYCYCLE_STATED,
  EDIT_ACTIVITYCYCLE,
  EDIT_ACTIVITYCYCLE_ENDED,
  GET_ACTIVITYCYCLE_STATED,
  GET_ACTIVITYCYCLE,
  GET_ACTIVITYCYCLE_ENDED,
  GET_ALL_ACTIVITYCYCLES_STATED,
  GET_ALL_ACTIVITYCYCLES,
  GET_ALL_ACTIVITYCYCLES_ENDED,
} from '../types/activitycycle_type';
import * as qs from 'qs';
import { handleError } from '../../shared/handleError';
import { setAlert } from './alert';

export const addActivitycycle = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_ACTIVITYCYCLE_STATED,
    });
    const { data } = await api.post(`/activitycycles`, formData);
    dispatch({
      type: ADD_ACTIVITYCYCLE,
      payload: data,
    });
    dispatch({
      type: ADD_ACTIVITYCYCLE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: ADD_ACTIVITYCYCLE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const addActivitycycleCalendar =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ADD_ACTIVITYCYCLE_STATED,
      });
      const { data } = await api.post(`/activitycycles/calendar`, formData);
      dispatch({
        type: ADD_ACTIVITYCYCLE,
        payload: data,
      });
      dispatch({
        type: ADD_ACTIVITYCYCLE_ENDED,
      });
    } catch (error) {
      dispatch({
        type: ADD_ACTIVITYCYCLE_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };

export const getActivitycycles =
  ({ pageNumber = '' }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_ACTIVITYCYCLES_STATED,
      });
      const queryParams = qs.parse(window.location.search.replace('?', ''));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });

      const { data } = await api.get(
        `/activitycycles?pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_ACTIVITYCYCLES,
        payload: data,
      });
      dispatch({
        type: GET_ACTIVITYCYCLES_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_ACTIVITYCYCLES_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getActivitycycle = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ACTIVITYCYCLE_STATED,
    });
    const { data } = await api.get(`/activitycycles/${id}`);

    dispatch({
      type: GET_ACTIVITYCYCLE,
      payload: data,
    });
    dispatch({
      type: GET_ACTIVITYCYCLE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: GET_ACTIVITYCYCLE_STATED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editActivitycycle = (id, formData) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_ACTIVITYCYCLE_STATED,
    });
    const { data } = await api.put(`/activitycycles/${id}`, formData);
    dispatch({
      type: EDIT_ACTIVITYCYCLE,
      payload: data,
    });
    dispatch({
      type: EDIT_ACTIVITYCYCLE_ENDED,
    });
  } catch (error) {
    dispatch({
      type: EDIT_ACTIVITYCYCLE_ENDED,
    });
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteActivitycycle = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/activitycycles/${id}`);
    dispatch(setAlert('Activitycycle Deleted Successfully', 'success'));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllActivitycycles =
  ({ term, value }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_ALL_ACTIVITYCYCLES_STATED,
      });
      const { data } = await api.get(
        `/activitycycles/all?term=${term}&value=${value}`
      );

      dispatch({
        type: GET_ALL_ACTIVITYCYCLES,
        payload: data,
      });
      dispatch({
        type: GET_ALL_ACTIVITYCYCLES_ENDED,
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_ACTIVITYCYCLES_ENDED,
      });
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };

export const handleErrorLocal = () => async (dispatch) => {};
